import { QueryClient } from '@tanstack/react-query';
import { LoaderFunction } from 'react-router-dom';

import { queries } from 'src/api/queries';
import { assertDefined } from 'src/utils';

export function loadContext(): NonNullable<unknown> {
  const element = document.getElementById('context-vars');
  return JSON.parse(element?.textContent ?? '{}');
}

export type LoaderData<T> = T extends (...args: any) => infer R
  ? R extends (...args: any) => infer R2
    ? Awaited<R2>
    : never
  : never;

type LoaderMap = Record<string, (queryClient: QueryClient) => LoaderFunction>;
const makeLoaderMap = <T extends LoaderMap>(m: T): T => m;

export const loaders = makeLoaderMap({
  usecaseLoader: (queryClient) => {
    return async ({ params: { usecaseId } }) => {
      assertDefined(usecaseId);
      const query = queries.usecase(parseInt(usecaseId, 10));
      return queryClient.ensureQueryData(query);
    };
  },
  usecasesForStoreLoader: (queryClient) => {
    return async ({ params: { storeKey } }) => {
      assertDefined(storeKey);
      const query = queries.usecasesForStore(storeKey);
      return queryClient.ensureQueryData(query);
    };
  },
});
